<template>
  <div>
    <CRow class="justify-content-between mb-3">
      <CCol sm="auto"
        ><div class="ui-type-display-lg">
          {{ $t("role.sidebar.products.showcase") }}
        </div></CCol
      >
      <CCol cols="6" class="d-flex align-items-center justify-content-end">
        <CInput
          v-model="searchTerm"
          :placeholder="$t('family.market.showcase.filters.search_es')"
          @keyup.enter="onSearch"
          class="mb-0 mr-2"
        >
          <template #prepend-content>
            <font-awesome-icon icon="search" />
          </template>
        </CInput>
        <CButton color="primary" @click="onSearch">
          {{ $t("common.search_label") }}
        </CButton>
      </CCol>
    </CRow>
    <CRow>
      <CCol>
        <CCard>
          <CCardBody>
            <CRow v-if="data" class="px-3 pt-0">
              <div v-if="data.length > 0" class="w-100">
                <Header
                  :data="[
                    $t('models.ppm.product'),
                    $t('models.ppm.variant'),
                    $t('models.productproducer.producer'),
                    $t('models.productproducer.category'),
                    $t('models.ppm.force_manual_price'),
                    $t('models.lot.is_active'),
                    $t('models.ppm.price'),
                    $t('models.lot.price'),
                    $t('models.ppm.margin'),
                    $t('models.ppm.flag'),
                    'Actions',
                  ]"
                />
                <Row
                  v-for="(item, index) in data"
                  :key="index"
                  :data="[
                    { data: productName(item), type: 'html' },
                    { data: variantName(item), type: 'html' },
                    {
                      data: item.ppl.productproducer.producer.role.name,
                      type: 'text',
                    },
                    { data: categoryName(item), type: 'html' },
                    { data: item.ppm.force_manual_price, type: 'boolean' },
                    { data: item.ppm.active, type: 'boolean' },
                    { data: price(item.ppm.price), type: 'html' },
                    { data: price(item.ppl.price), type: 'html' },
                    { data: margin(item), type: 'html' },
                    { data: banner(item.ppm.flag), type: 'html' },
                    { data: '', type: 'actions' },
                  ]"
                  :border="true"
                  :topAligned="true"
                >
                  <template #actions>
                    <div class="d-flex justify-content-end">
                      <CButton
                        class="mr-2 mt-2"
                        size="sm"
                        color="primary"
                        @click="editProduct(item)"
                      >
                        <font-awesome-icon icon="edit" />
                      </CButton>
                    </div>
                  </template>
                </Row>
                <CRow class="mt-3">
                  <CCol>
                    <Pagination
                      :data="pagination"
                      @paginate="fetchData"
                      :maxVisiblePages="7"
                    />
                  </CCol>
                </CRow>
              </div>
              <div
                v-else
                class="d-flex justify-content-center align-items-center w-100"
              >
                <CSpinner color="primary" />
              </div>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <ShowcasePricesModal
      :show.sync="modal.show"
      :title="modal.title"
      :values="modal.values"
      :edit-mode="modal.editMode"
      :edit-id="modal.editId"
      :flags="flags"
      @submitted="fetchData"
    />
  </div>
</template>

<script>
import Vue from "vue";
import { apiGetDirectUrl } from "../../../helpers/apiHelper";
import Header from "../../../common/table/Header.vue";
import Row from "../../../common/table/Row.vue";
import Pagination from "../../../common/table/Pagination.vue";
import UiSelect from "../../../common/form/UiSelect.vue";
import ShowcasePricesModal from "./ShowcasePricesModal.vue";

export default Vue.extend({
  name: "Products",
  components: {
    Row,
    Header,
    Pagination,
    UiSelect,
    ShowcasePricesModal,
  },

  data() {
    return {
      loading: true,
      data: [],
      searchTerm: "",
      pagination: {
        count: 0,
        next: null,
        previous: null,
        limit: 12,
        offset: 0,
      },
      modal: {
        show: false,
        title: "",
        values: {},
        editMode: false,
        editId: null,
      },
      flags: [
        { value: 1, label: this.$t("models.ppm.flags.options1") },
        { value: 2, label: this.$t("models.ppm.flags.option2") },
        { value: 3, label: this.$t("models.ppm.flags.option3") },
        { value: 4, label: this.$t("models.ppm.flags.option4") },
        { value: 5, label: this.$t("models.ppm.flags.option5") },
        { value: 6, label: this.$t("models.ppm.flags.option6") },
      ],
    };
  },

  computed: {
    lang: function () {
      return this.$i18n.locale;
    },
  },

  methods: {
    editProduct(item) {
      this.modal.title = `${this.productName(item)} - ${this.variantName(
        item
      )}`.replace(/<\/?strong>/g, "");
      this.modal.values = item;
      this.modal.editMode = false;
      this.modal.editId = item.id;
      this.modal.show = true;
    },

    categoryName(item) {
      return `${
        item.ppl.productproducer.category.translations[this.lang].name
      }`;
    },

    productName(item) {
      return `<strong>${
        item.ppl.productproducer.translations[this.lang].name
      }</strong>`;
    },

    variantName(item) {
      return `<strong>${item.ppl.translations[this.lang].name}</strong>`;
    },

    margin(item) {
      const mrg = item.ppm.price - item.ppl.price;
      const mrg_p = (mrg * 100) / item.ppm.price;
      return item.auto_price === true
        ? `${this.$store.getters["connections/currencySymbol"]} ${mrg.toFixed(
            2
          )} (Auto) <br> ${mrg_p.toFixed(2)} %`
        : `${this.$store.getters["connections/currencySymbol"]} ${mrg.toFixed(
            2
          )} <br> ${mrg_p.toFixed(2)} %`;
    },

    price(value) {
      return `${
        this.$store.getters["connections/currencySymbol"]
      } ${value.toFixed(2)}`;
    },

    banner(item) {
      if (item !== 0) {
        const flag = this.flags.find((flag) => flag.value === item);
        if (flag) {
          return `<span class="badge badge-secondary px-2">${flag.label}</span>`;
        }
      }
      return "";
    },

    onSearch() {
      this.pagination.offset = 0;
      this.fetchData();
    },

    buildFilterQuery() {
      if (!this.searchTerm || this.searchTerm.trim() === "") {
        return "";
      }
      const term = this.searchTerm.toLowerCase().trim();
      const lang = this.$i18n.locale;
      const filters = [
        `substringof('${term}',tolower(cast(ppl/productproducer/category/parent/translations/${lang}/name, 'Edm.String')))`,
        `substringof('${term}',tolower(cast(ppl/productproducer/category/translations/${lang}/name, 'Edm.String')))`,
        `substringof('${term}',tolower(cast(ppl/productproducer/producer/role/name, 'Edm.String')))`,
        `substringof('${term}',tolower(cast(ppl/productproducer/translations/${lang}/name, 'Edm.String')))`,
        `substringof('${term}',tolower(cast(ppl/translations/${lang}/name, 'Edm.String')))`,
        `substringof('${term}',tolower(cast(ppl/id, 'Edm.String')))`,
      ];
      return `&$filter=(${filters.join(") or (")})`;
    },

    async fetchData(page = null) {
      this.loading = true;

      if (page) {
        this.pagination.offset = (page - 1) * this.pagination.limit;
      }

      const filterQuery = this.buildFilterQuery();
      const response = await apiGetDirectUrl(
        `/api/market/${this.$store.state.role.id}/ppm/?$inlinecount=allpages&$skip=${this.pagination.offset}&$top=${this.pagination.limit}${filterQuery}`
      );
      if (response && response.status === 200) {
        this.loading = false;
        this.data = response.data.Items;
        this.pagination = {
          count: response.data.Count,
          limit: this.pagination.limit,
          offset: this.pagination.offset,
        };
        //scrollToTopOfpage(this);
      } else {
        this.loading = false;
        this.$store.dispatch("toaster/add", {
          title: this.$t("role.finance.invoicesSettings.attention"),
          text: "Error loading products data",
          color: "danger",
          autohide: true,
        });
      }
    },
  },

  async created() {
    await this.fetchData();
  },
});
</script>
